<script lang="ts">
  export let message = "";
</script>

<div class="message">
  <i>{message}</i>
</div>

<style lang="scsc">
  .message {
    padding: 5rem 0;
  }
</style>
